import { lazy, memo, Suspense } from "react";

const AppAssistenteIA = lazy(() => import("@/components/avulsos/appAssistenteIA/AppAssistenteIA"));
const QuickPanel = lazy(() => import("@/components/theme-layouts/components/quickPanel/QuickPanel"));

/**
 * The right side layout 1.
 */
function RightSideLayout1() {
	return (
		<Suspense>
			<QuickPanel />
			<AppAssistenteIA />
		</Suspense>
	);
}

export default memo(RightSideLayout1);
